import React from "react";
import questionsPic from "../../assets/pictures/19333428.jpg";

const About = () => {
  return (
    <div className="about">
      <img src={questionsPic} alt="questions" className="questionsPic" />
      <h4 className="aboutH4">
        Over BZ Co - Uw Professionele Schoonmaakpartner
      </h4>
      <p className="aboutInfo">
        Bij BZ Co zijn we toegewijd aan het leveren van professionele
        schoonmaakdiensten van de hoogste kwaliteit. Met een sterke focus op
        vakmanschap en klanttevredenheid, zijn we uw betrouwbare
        schoonmaakpartner voor alle soorten projecten.
      </p>

      <h4 className="aboutH4">Onze Missie</h4>
      <p className="aboutInfo">
        Onze missie is eenvoudig maar krachtig: we streven ernaar om elke ruimte
        die we schoonmaken te transformeren naar een onberispelijke omgeving. We
        geloven dat een schone en frisse ruimte niet alleen esthetisch
        aantrekkelijk is, maar ook bijdraagt aan het welzijn en de
        productiviteit van mensen.
      </p>

      <h4 className="aboutH4">Wat betekent de SNA-verklaring voor u?</h4>
      <p className="aboutInfo">
        De SNA-verklaring is een keurmerk dat aangeeft dat ons bedrijf voldoet
        aan strenge normen en regels in de schoonmaakbranche. Dit betekent dat
        we:
      </p>
      <li className="aboutLi">
        Betrouwbare partner zijn voor onze klanten en leveranciers
      </li>
      <li className="aboutLi">
        Voldoen aan alle wettelijke en financiële verplichtingen
      </li>
      <li className="aboutLi">
        Verantwoordelijkheid nemen voor onze medewerkers en hun
        arbeidsvoorwaarden.
      </li>
      <li className="aboutLi">
        Transparantie en compliance hoog in het vaandel hebben staan.
      </li>

      <h4 className="aboutH4">Kies voor BZ Co met vertrouwen</h4>
      <p className="aboutInfo">
        Als u op zoek bent naar een schoonmaakpartner die professionaliteit,
        kwaliteit en betrouwbaarheid hoog in het vaandel heeft staan, dan is BZ
        Co de juiste keuze. Onze SNA-certificering is een bewijs van onze
        toewijding aan excellentie in de schoonmaakbranche. Neem contact met ons
        op om te bespreken hoe we uw schoonmaakbehoeften kunnen vervullen.
      </p>
    </div>
  );
};

export default About;
